<script>
export default {
  name: "FileCard",
  props: {
    name: {
      type: String,
      required: true
    },
    ext: {
      type: String,
      required: true
    },
    size: {
      type: Number,
      required: true,
    },
    url: {
      type: String,
      required: true
    }
  },
  computed: {
    cleanName() {
      if(!this.name.endsWith(this.ext)) return this.name;
      return this.name.slice(0, this.ext.length * -1);
    },
    documentType() {
      const cleanExtension = this.ext.startsWith(".") ? this.ext.slice(1) : this.ext;

      return `${cleanExtension.toUpperCase()} Datei`;
    },
    sizeString() {
      if(this.size < 1024) return `${Math.floor(this.size)} KB`;

      return `${Math.floor(this.size / 1024)} MB`;
    },
    downloadUrl() {
      return process.env.VUE_APP_API_BASE_URL + this.url;
    }
  }
}
</script>

<template>
  <v-card class="file-card" download :href="downloadUrl">
    <v-card-title class="primary-text file-title">{{ cleanName }}</v-card-title>
    <v-card-text class="info-container">
      <div>{{ documentType }} (<span class="font-weight-bold">{{ sizeString }}</span>)</div>
      <v-btn color="primary" icon style="align-self: flex-end"><v-icon>mdi-download</v-icon></v-btn>
    </v-card-text>
  </v-card>
</template>

<style scoped>
.file-title {
  font-weight: bold !important;
  font-size: 16px !important;
  line-height: 20px;
  padding-bottom: 8px;
}

.info-container {
  padding-bottom: 0;
  display: flex;
  flex-direction: column;
  padding-right: 2px;
}

.file-card {
  border-radius: 5px !important;
}

.file-card:hover {
  text-decoration: none !important;
  cursor: pointer;
}
</style>